export default __webpack_public_path__ + "static/media/pictogramBeaconPrizeDrawWin40.21cfb2ed.svg";